<app-abstract-dialog
        [dialogWidth]="'auto'"
        [showVoiceControls]="false">
    <ng-container abstract-content>
        <app-popup-image class="image" *ngIf="multimediaType === fileTypeImage"
                         [imagePath]="multimediaPath">
        </app-popup-image>
        <app-popup-video class="video" *ngIf="multimediaType === fileTypeVideo"
                         [videoPath]="multimediaPath">
        </app-popup-video>
    </ng-container>
</app-abstract-dialog>
